<template>
    <div>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item style="float: right">
                <el-button type="primary" @click="saveDataList()">保存</el-button>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button @click="currentChangeHandle(1)">刷新列表</el-button>
            </el-form-item>
            <el-form-item style="float: right">
                <el-button @click="reloadConfig(true)">重置表别名</el-button>
                <el-button @click="reloadConfig(false)">解析字段</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                row-key="id"
                border
                stripe
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%"
        >
            <el-table-column type="selection" fixed width="55"></el-table-column>
            <el-table-column
                    fixed
                    type="index"
                    header-align="center"
                    align="left"
                    label="序号"
                    width="60"
                    :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column
                    fixed
                    prop="columnName"
                    header-align="center"
                    align="left"
                    width="220"
                    label="字段名称"
            >
            </el-table-column>
            <el-table-column
                    prop="displayName"
                    header-align="center"
                    align="left"
                    label="显示名"
            >
                <template slot-scope="scope">
                    <el-input v-model="scope.row.displayName"></el-input>
                </template>
            </el-table-column>

          <el-table-column
                    prop="columnWidth"
                    header-align="center"
                    align="left"
                    label="列宽(px)"
                    width="100px"
            >
                <template slot-scope="scope">
                    <el-input v-model.trim="scope.row.columnWidth" placeholder="带px"></el-input>
                </template>
            </el-table-column>

          <el-table-column
                    prop="patternRegex"
                    header-align="center"
                    align="left"
                    label="时间格式"
                    width="140px"
            >
                <template slot-scope="scope">
                    <el-input v-model.trim="scope.row.patternRegex" placeholder="输入时间格式"></el-input>
                </template>
            </el-table-column>
            <el-table-column
                    prop="datasourceType"
                    header-align="center"
                    align="left"
                    label="数据源类型"
                    width="140px"
            >
                <template slot-scope="scope">
                    <el-select
                            v-model="scope.row.datasourceType"
                            placeholder="数据源类型"
                            style="display: block; margin-bottom: 10px"
                    >
                        <el-option
                                v-for="item in datasourceTypeList"
                                :key="item.id"
                                :label="item.text"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column
                    prop="datasource"
                    header-align="center"
                    align="left"
                    label="数据源"
                    width="140px"
            >
                <template slot-scope="scope">
<!--                    <el-select
                            v-model="scope.row.datasource"
                            v-if="scope.row.datasourceType==2"
                            placeholder="数据源类型"
                            style="display: block; margin-bottom: 10px"
                    >
                        <el-option
                                v-for="item in dictCateList"
                                :key="item.id"
                                :label="item.text"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>-->
                    <el-input v-if="scope.row.datasourceType==3|| scope.row.datasourceType==99|| scope.row.datasourceType==2"
                              v-model="scope.row.datasource"></el-input>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="showInList"
                    header-align="center"
                    align="left"
                    label="是否显示"
                    width="120px"
            >
                <template slot-scope="scope">
                  <el-switch size="mini" v-model="scope.row.showInList"
                             :active-value="true"
                             :inactive-value="false"
                             active-text="是"
                             inactive-text="否"
                  ></el-switch>
                </template>
            </el-table-column>
          <el-table-column
                    prop="isQueryParam"
                    header-align="center"
                    align="left"
                    label="是否查询条件"
                    width="120px"
            >
                <template slot-scope="scope">

                  <el-switch size="mini" v-model="scope.row.isQueryParam"
                             :active-value="true"
                             :inactive-value="false"
                             active-text="是"
                             inactive-text="否"
                  ></el-switch>
                </template>
            </el-table-column>
            <el-table-column
                    prop="sort"
                    header-align="center"
                    align="left"
                    label="排序"
                    width="125px"
            >
                <template slot-scope="scope">
                    <el-input-number size="mini" style="width: 100px;" v-model="scope.row.sort"></el-input-number>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination> -->
        <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="totalCount"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
        </pagination> 
    </div>
</template>

<script>
    import axios from "axios";
    import Pagination from '@/components/Pagination.vue';
    export default {
        components:{Pagination},
        props: {
            formId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                dataForm: {
                    searchKey: "",
                    formId: "",
                },
                datasourceTypeList: [],
                dictCateList: [],
                pageIndex: 1,
                pageSize: 10,
                totalCount: 0,
                dataList: [],
                groupList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                itemListBatchsettingVisible: false,
                importFieldListVisible: false,
            };
        },
        activated() {

        },
        mounted() {
            this.initSelectData()
            this.dataForm.formId = this.formId;
            this.getDataList();
        },
        methods: {
            getHttpReq(url, method = "post", extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL:'',
                };
                ops = Object.assign(ops, extOps);
                return this.$http(ops);
            },
            selectDatasourceType(event, row) {
                // row.datasource=''
            },
            initSelectData() {
                let _self = this;
                axios
                    .all([
                        this.getHttpReq(this.$http.adornUrl('/customform/getEnumList/0?required=true'), "get"),
                        // this.getHttpReq("/api/sys/dict/getDictCategoryList2", "get"),
                    ])
                    .then(
                        axios.spread(function (datasourceTypes, dictCataegory) {
                            let tmp = datasourceTypes.data
                            let result = []
                            for (var i = 0; i < tmp.length; i++) {
                                let item = tmp[i];
                                if (item.id == 4 || item.id == 5 || item.id == 6) {
                                    continue
                                }
                                result.push(item)
                            }
                            _self.datasourceTypeList = _self.transformToInt(result);
                            _self.dictCateList =  (dictCataegory && dictCataegory.data) || [];
                        })
                    );
            },
            transformToInt(data) {
                let tmp = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.id = parseInt(element.id)
                    if (isNaN(element.id)) {
                        element.id = 0
                    }
                    tmp.push(element)
                }
                return tmp
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            paginationChange(obj){
                this.pageIndex= obj.page||1
                this.pageSize=obj.limit||10
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                this.$http({
                    url: this.$http.adornUrl("/customform/fromdatasetfield/listSingle"),
                    method: "post",
                    baseURL: '',
                    data: {
                        filter: {
                            formId: this.dataForm.formId,
                        },
                        page: this.pageIndex,
                        rows: this.pageSize,
                        searchKey: this.dataForm.searchKey,
                    },
                }).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows;
                        this.totalCount = data.total;
                        this.pageIndex = data.pageIndex;
                    } else {
                        this.dataList = [];
                        this.totalCount = 0;
                        this.pageIndex = 1;
                    }
                    this.dataListLoading = false;
                });
            },
            saveDataList() {
                this.$http({
                    url: this.$http.adornUrl("/customform/fromdatasetfield/batchUpdate"),
                    method: "post",
                    baseURL: '',
                    data: this.dataList,
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                });
            },
            reloadConfig(resetTab) {
                this.$http({
                    url: this.$http.adornUrl("/customform/fromdatasetfield/reload/" + this.formId),
                    method: "post",
                    baseURL: '',
                    data: {table:resetTab},
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                });
            }
        },
    };
</script>
